import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CalendarStore } from '@calendar/calendar.store';
import { FlightParams } from '@shared/models/flight-params';
import { RouteParameterStore } from '@shared/services/route-parameter.store';
import { tap } from 'rxjs';
import { NavbarInstructionComponent } from '../navbar-instruction/navbar-instruction.component';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrl: './bottom-nav.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomNavComponent {
  currentScreen$ = this.routeParameterStore.currentScreen$.pipe(
    tap((screen) => {
      // console.log(screen);
      this.currentScreen = screen;
    }),
  );
  flightParams: FlightParams | null = null;

  currentScreen: string | null = '';

  constructor(
    private calendarStore: CalendarStore,
    private routeParameterStore: RouteParameterStore,
    private router: Router,
    private dialog: MatDialog,
  ) {
    // Keep flight params from URL updated. Used to create sequence url.
    this.routeParameterStore.flightParams$.subscribe((flightParams) => {
      this.flightParams = flightParams;
    });
  }

  onCalendarClick(): void {
    this.router.navigate(['/calendar']);
  }

  onSequenceClick(): void {
    if (this.currentScreen === 'sequence') {
      return;
    }

    // Create sequence URL from current flight URL (on flight screen).
    if (this.flightParams?.sequenceParams) {
      const { sequenceParams } = this.flightParams;

      this.router.navigate([
        `/sequence/${sequenceParams.number}/${sequenceParams.seat}/${sequenceParams.date}`,
      ]);
    } else {
      // Not on flight screen.
      const nextSequence = this.calendarStore.getNextSequenceProperties();

      if (nextSequence) {
        this.router.navigate([
          `/sequence/${nextSequence.number}/${nextSequence.seat}/${nextSequence.date}`,
        ]);
      } else {
        this.dialog.open(NavbarInstructionComponent, {
          data: 'sequence',
        });
      }
    }
  }

  onFlightClick(): void {
    if (this.currentScreen === 'flight') {
      return;
    }

    const nextFlightUrl = this.calendarStore.getNextFlightUrl();
    // console.log(nextFlightUrl);

    if (nextFlightUrl) {
      this.router.navigate([nextFlightUrl]);
    } else {
      this.dialog.open(NavbarInstructionComponent, {
        data: 'flight',
      });
    }
  }

  // Determine whether to display 'This Flight' or 'Next Flight'.
  getSequenceLabel(): string {
    if (this.currentScreen === 'flight') {
      return 'This Sequence';
    } else if (this.currentScreen === 'sequence') {
      return 'Sequence';
    } else {
      return 'Next Sequence';
    }
  }

  getFlightLabel(): string {
    if (this.currentScreen === 'flight') {
      return 'Flight';
    } else {
      return 'Next Flight';
    }
  }

  onSearchClick(): void {
    this.router.navigate(['/search']);
  }
}
